import { useList } from 'app/definitions';
import InfinitiveList from 'app/modules/ui/components/list/infinitive';
import React from 'react';
import { InspectionPOItem } from '../../types';
import { POItem } from './Item';
import useInfiniteScroll from 'app/modules/ui/hooks';
import isEmpty from 'lodash/isEmpty';

type ListPOItemProps = {
  inspectionId: string | number;
};

export const ListPOItem = (props: ListPOItemProps) => {
  const { inspectionId } = props;
  // const [hasMore, setHasMore] = React.useState(false);
  const [pages, setPages] = React.useState<{
    [key: string | number]: InspectionPOItem[];
  }>({});
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 5
  });
  const { data, isLoading, isUninitialized, isFetching } = useList<{
    list: InspectionPOItem[];
    pagination: {
      total: number;
    };
  }>({
    resource: 'inspections/:id/po-items',
    pagination,
    meta: {
      id: inspectionId
    },
    queryOption: {
      skip: !inspectionId
    }
  });

  const allPageData = React.useMemo(() => {
    if (isEmpty(pages)) return [];
    return Object.values(pages).reduce((acc, page) => {
      return [...acc, ...page];
    }, []);
  }, [pages]);

  const hasMore = React.useMemo(() => {
    if (data?.pagination) {
      return allPageData.length < data?.pagination?.total;
    }
    return false;
  }, [allPageData.length, data?.pagination]);

  const { loaderRef } = useInfiniteScroll({
    loadMore: async () => {
      if (isUninitialized) return;
      setPagination((prev) => {
        return {
          ...prev,
          current: prev.current + 1
        };
      });
    },
    hasMore,
    isLoading: isUninitialized ? true : isLoading || isFetching
  });

  React.useEffect(() => {
    if (data?.list) {
      setPages((prev) => {
        return {
          ...prev,
          [pagination.current]: [...data.list]
        };
      });
    }
  }, [data]);

  return (
    <InfinitiveList<InspectionPOItem>
      loaderRef={loaderRef}
      infinitiveConfig={{
        hasMore: hasMore,
        dataLength: (allPageData ?? [])?.length
      }}
      dataSource={allPageData}
      rowKey={(item) => item.id}
      itemHeight={450}
      split={false}
      renderItem={(item, index) => {
        return <POItem ordinalNumber={index + 1} id={item.id} />;
      }}
    />
  );
};
